import { Box, Button, styled } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AuthenticateLayout from "../../components/AuthenticateLayout";
import ChangeLanguage from "../../components/ChangeLanguage";
import { upperCase } from "lodash";
import { APP_NAME } from "../../constants";
import { useMemo } from "react";
import TextWrapper from "../../components/Text";
import RewardButton from "../../components/RewardButton";
import { MainLayout } from "../../layouts/main";
import { ENV } from "../../configs/env";


type PlatformType = keyof typeof APP_NAME;

const EngageWrapper = styled(Box)({
  "& .wrapper": {
    paddingLeft: "35px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    paddingBottom: "50px",
  },
  "& .error_noti": {
    width: "100%",
    borderRadius: 5,
    marginBottom: 35
  },
  "& .error_noti .page_not_found svg": {
    color: "red",
    marginRight: 10,
  },
  "& .error_noti .page_not_found .inner": {
    display: "flex",
    maxWith: "max-content",
    margin: "auto",
    color: "#3572a6"
  },
  "& .error_noti .error_message": {
    display: "block",
    fontSize: 16,
    padding: 5,
    textAlign: "center",
    maxWidth: "fit-content",
    margin: "auto",
    marginTop: 10,
    borderRadius: 5,
    color: "#3572a6",
  },
  "& .error_noti .page_not_found": {
    display: "flex",
    fontSize: 16,
    marginTop: "20%",
  }
});

const SubcampaignInvalidTextWrapper = styled(TextWrapper)({
  textAlign: "center",
  display: "block",
  color: "#3572a6",
  fontSize: 16,
  padding: 10,
  paddingTop: 50,
  lineHeight: 2,
  whiteSpace: "pre-line",
});


const CampaignStatus: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const status = location.pathname.split("/")[2];
  const searchParams = new URLSearchParams(location.search);
  const platformParam = upperCase(searchParams.get("platform") || "");
  const platformName = APP_NAME[platformParam as PlatformType];
  const isSuccessPage: boolean = status === "success" && platformName !== undefined;
  const pageNotFoundMessage = useMemo(() => t("campaignIsnotAvailable"), [t]);
  const { background, banner_image_corner } = location.state || {};
  const session_id = localStorage.getItem("session-id") || null;

  return (
    <EngageWrapper>
      {session_id && <MainLayout />}
      <AuthenticateLayout
        button={!ENV.HIDE_TRANSLATOR && (session_id ? RewardButton : () => <ChangeLanguage />)}
        isLoading={false}
        background={background}
        bannerImageCorner={banner_image_corner}
        hideLogo={ENV.HIDE_LOGO}
      >
        <Box
          px={2.5}
          mt={6}
          pb={21}
          display="flex"
          justifyContent="center"
          flexDirection="column"
        >
          {
            !isSuccessPage ? (
              <div>
                <SubcampaignInvalidTextWrapper>
                  {pageNotFoundMessage}
                </SubcampaignInvalidTextWrapper>
              </div>
            ) : (
              <>
                <div className="error_noti">
                  <div className="page_not_found error_message">
                    <div className="inner">
                      <p> {`${t("PleaseCheckYourReward").replace("{}", platformName)}`} </p>
                    </div>
                  </div>
                </div>
              </>
            )
          }
        </Box>
      </AuthenticateLayout>
    </EngageWrapper>
  );
};

export default CampaignStatus;
